import { render, staticRenderFns } from "./editFile.vue?vue&type=template&id=b2c2614c&scoped=true"
import script from "./editFile.vue?vue&type=script&lang=js"
export * from "./editFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c2614c",
  null
  
)

export default component.exports